



































import {Component, Inject, Mixins, Provide} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import FlexGridSettingsDialogColumns from './FlexGridDisplaySettingsEditDialogColumns.vue';
import FlexGridSettingsDialogGroups from './FlexGridDisplaySettingsEditDialogGroups.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CTextField from '@/components/base/textField/CTextField.vue';
import {generateId} from '@/utils';
import {SET_EDITING_TO_SHOW_ONLY_VISIBLE_COLUMNS} from '@/store/modules/flexGridModule/flexGrid-mutation-types';

/**
 * @requires ./FlexGridDisplaySettingsEditDialogColumns.vue
 * @requires ./FlexGridDisplaySettingsEditDialogGroups.vue
 */
@Component({
    components: {
        CTextField,
        CEditDialog,
        CCheckbox,
        groups: FlexGridSettingsDialogGroups,
        columns: FlexGridSettingsDialogColumns,
    },
})
export default class FlexGridSettingsEditDialog extends Mixins(EditDialogMixin) {
    @Inject() moduleName!: string;
    @Inject() commit!: Function;

    private fixColumns = false;
    private unwatchFixColumns: Function | null = null;

    get editingToShowOnlyVisibleColumns(): boolean {
        return this.$store.state[this.moduleName].editingToShowOnlyVisibleColumns;
    }
    set editingToShowOnlyVisibleColumns(value: boolean) {
        this.commit(SET_EDITING_TO_SHOW_ONLY_VISIBLE_COLUMNS, value);
    }

    onFixColumnsChange(value: boolean) {
        if (value) {
            const separator = {_isSeparator: true, _id: 'separator'};
            if (this.data.CountAnchoredColumns !== null && this.data.CountAnchoredColumns !== 0) {
                this.data.Columns.splice(this.data.CountAnchoredColumns, 0, separator);
            } else {
                this.data.Columns = [separator, ...this.data.Columns];
                this.data.CountAnchoredColumns = 0;
            }
        } else {
            this.data.Columns = this.data.Columns.filter((item: any) => !item._isSeparator);
            this.data.CountAnchoredColumns = null;
        }
    }

    prepareData(data: any) {
        const columnsCallback = (column: any) => {
                column._id = generateId();
                column._edit = false;
                if (column.Groupable) column.Group = false;
                if (column.Columns) column.Columns.forEach(columnsCallback);
            },
            groupsCallback = (column: any) => {
                if (column.Key && column.Groupable && column.Key === group.Key) {
                    column.Group = true;
                    group.Caption = column.CustomCaption ? column.CustomCaption : column.DefaultCaption;
                } else {
                    if (column.Columns) column.Columns.forEach(groupsCallback);
                }
            };
        let group: any;
        data.Columns.forEach(columnsCallback);
        data.Groups.forEach((item: any) => {
            group = item;
            data.Columns.forEach(groupsCallback);
        });
        return data;
    }

    async onColumnsAdd() {
        this.data.Columns.push({
            Columns: [],
            CustomCaption: this.$t('Common.FlexGrid.NewColumn'),
            DefaultCaption: null,
            Visible: true,
            _id: generateId(),
            _edit: false,
        });
        await this.$nextTick();
        const el = (this.$refs.columns as any).$el.querySelector('.card-body');
        if (el) {
            el.scroll(0, el.scrollHeight);
        }
    }

    @Provide()
    onColumnChange(column: any) {
        const group = this.data.Groups.find((group: any) => column.Key === group.Key);
        if (group && !column.Group) {
            this.data.Groups = this.data.Groups.filter((group: any) => group.Key != column.Key);
        }
        if (!group && column.Group)
            this.data.Groups.push({
                Key: column.Key,
                Caption: column.CustomCaption ? column.CustomCaption : column.DefaultCaption,
            });
        if (group && column.Group) group.Caption = column.CustomCaption ? column.CustomCaption : column.DefaultCaption;
    }

    onGroupDelete(item: any) {
        this.data.Groups = this.data.Groups.filter((group: any) => group.Key != item.Key);
        let success = false;
        const callback = (columns: any) => {
            for (let i = 0; i < columns.length; i++) {
                if (success) break;
                if (columns[i].Key === item.Key) {
                    columns[i].Group = false;
                    success = true;
                    break;
                }
                if (item.Columns) callback(item.Columns);
            }
        };
        callback(this.data.Columns);
    }

    init(data: any) {
        this.data = this.prepareData(data);
        this.fixColumns = this.data.CountAnchoredColumns !== null;
    }

    beforeOpen() {
        this.unwatchFixColumns = this.$watch('fixColumns', this.onFixColumnsChange);
    }

    beforeClose() {
        if (this.unwatchFixColumns !== null) {
            this.unwatchFixColumns();
            this.unwatchFixColumns = null;
        }
        this.fixColumns = false;
    }

    afterClose() {
        if (this.editingToShowOnlyVisibleColumns) this.editingToShowOnlyVisibleColumns = false;
    }

    afterValidateSuccess() {
        if (this.fixColumns) {
            this.data.CountAnchoredColumns = this.data.Columns.findIndex((item: any) => item._isSeparator);
            this.data.Columns = this.data.Columns.filter((item: any) => !item._isSeparator);
        }
    }

    onColumnMakeVisible(item: any) {
        let itemIndex = this.data.Columns.findIndex((el: any) => el._id === item._id);
        let lastVisibleItem = this.data.Columns.slice()
            .reverse()
            .find((el: any) => el.Visible);
        let lastVisibleItemIndex = this.data.Columns.findIndex((el: any) => el._id === lastVisibleItem._id);
        let found = false;

        item.Visible = true;

        if (itemIndex === -1) {
            const callback = (array: any[]) => {
                for (let i = 0; i < array.length; i++) {
                    if (found) break;
                    let elem = array[i];
                    if (elem._id === item._id) {
                        array.splice(i, 1);
                        found = true;
                        break;
                    } else if (elem.Columns.length > 0) callback(elem.Columns);
                }
            };
            callback(this.data.Columns);
            this.data.Columns.push(item);
        } else {
            this.data.Columns.splice(itemIndex, 1);
            this.data.Columns.splice(lastVisibleItemIndex, 0, item);
        }
    }
}
